import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { DividerComponent, HeadingComponent, IconComponent } from '@core/user-interface-legacy';

import { TellentAssistantBrandMarkComponent } from '../brand-mark/tellent-assistant-brand-mark.component';

@Component({
  selector: 'tellent-assistant-empty-state',
  imports: [
    DividerComponent,
    HeadingComponent,
    IconComponent,
    TellentAssistantBrandMarkComponent,
    TranslatePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (loading()) {
      <div class="skeleton"></div>
    } @else {
      <header class="intro">
        <div class="brand-wrap">
          <tellent-assistant-brand-mark />
        </div>
        <rt-heading variant="heading large lighter" class="greeting">
          {{ 'tlc.tellent_assistant.empty_state.greeting' | translate: { name: userName() } }}
        </rt-heading>
        <rt-heading variant="heading large-x">
          {{ 'tlc.tellent_assistant.empty_state.heading' | translate }}
        </rt-heading>
      </header>
      <ul class="suggestions">
        @for (suggestion of suggestions(); track suggestion) {
          @if (!$first) {
            <rt-divider />
          }
          <li class="suggestion" (click)="suggestionClick.emit(suggestion)">
            <span class="label">{{ suggestion }}</span>
            <rt-icon
              name="keyboard-arrow-right"
              colorToken="colorIconAiStrongDefault"
              class="chevron"
            />
          </li>
        }
      </ul>
    }
  `,
  styleUrl: './tellent-assistant-empty-state.component.less',
  host: {
    '[class.expanded]': 'expanded()',
  },
})
export class TellentAssistantEmptyStateComponent {
  public readonly userName = input.required<string>();
  public readonly suggestions = input.required<readonly string[]>();
  public readonly loading = input<boolean>(false);
  public readonly expanded = input.required<boolean>();
  public readonly suggestionClick = output<string>();
}
